export default class ListWorkOrderExternalNotificationsRequest {
    public workOrderId: string = "";
}